/**
 * Delayed Tasks
 * Runs tasks after page and ads have loaded
 * version 1.1.0
 *
 * Using Semantic Versioning, please update accordingly to keep files in sync across code bases
 *
 * Given a version number MAJOR.MINOR.PATCH, increment the:
 *  1. MAJOR version when you implement a full re-build of the architecture,
 *  2. MINOR version when you add functionality, and
 *  3. PATCH version when you implement bug fixes or make small  tweaks to current functionality.
 */
define('delayedtasks',[
    "jquery",
    "ads",
    "logging"
], function ($, ads, logging) {
    "use strict";

    var _ModuleName = "Delayed Tasks";
    var _config = {
        enabled: true
    };

    var _tasks = [];
    var _delayComplete = false;

    var init = function () {
        if (_config.enabled) {
            // wait for page load
            $(function() {
                // ensure ads have loaded
                ads.runAfterAdsLoaded(function () {
                    // now we can run our tasks
                    _handleDelayComplete();
                });
            });
        } else {
            _handleDelayComplete();
        }
    };

    var registerTask = function (task) {
        if (typeof task === 'function') {
            // if the page load is already complete, and delay no longer needed
            // or if this isn't even enabled, then go ahead and run the task
            // otherwise, store it in a queue
            if (_delayComplete || !_config.enabled) {
                task();
            } else {
                _tasks.push(task);
            }
        }
    };

    var _handleDelayComplete = function () {
        ;

        if (_delayComplete) { return; }
        _delayComplete = true;

        for (var i = 0; i < _tasks.length; i++) {
            var task = _tasks[i];
            if (typeof task === 'function') {
                task();
            }
        }
        _tasks = [];
    };

    return {
        init: init,
        registerTask: registerTask
    };
});
